import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap5';
import { Link, Navigate, useLocation } from 'react-router-dom';

import routes from 'app/routes';
import BlockWithCheckbox from 'components/new_ui/Items/BlockWithCheckbox';
import formatCurrency from 'components/utils/formatCurrency';
import useCustomServices from 'components/Common/PlanCustomServices/Hooks/useCustomServices';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import planTotal from '../../utils/planTotal';
import ShortSummary from '../Widgets/ShortSummary';

import { useContext } from '../../Context';

export default function Services() {
  const { state } = useLocation();
  const { data } = state || {};

  const { state: statePlans } = useContext();

  let mark = '';

  switch (statePlans.currency) {
    case 'GBP':
      mark = '£';
      break;
    case 'CHF':
      mark = '₣';
      break;
    default:
      mark = '$';
  }

  const abbr = statePlans.currency;

  if (data === undefined) {
    return <Navigate to={routes.managers.plans.new.choose_template} replace />;
  }

  const { services } = useCustomServices('q[required_for_manager_false]=1');

  const [plan, setPlan] = useState(data.plan);

  const selectedTopics = plan ? plan.attributes.monthly_custom_records.map((item) => item.name) : [];

  const onServiceClicked = (serviceId) => {
    let selectedServices = plan.attributes.monthly_custom_records;
    const service = services.find((item) => item.id === serviceId);
    if (service) {
      if (selectedServices.find((item) => item.name === service.attributes.name)) {
        selectedServices = selectedServices.filter((item) => item.name !== service.attributes.name);
      } else {
        selectedServices = [...selectedServices, {
          id: service.id,
          name: service.attributes.name,
          price: service.attributes.currency_prices
            .find((item) => item.currency === abbr)?.price,
        }];
      }

      const newPlan = {
        ...plan,
        attributes: {
          ...plan.attributes,
          monthly_custom_records: selectedServices,
        },
      };

      setPlan({
        ...newPlan,
        attributes: {
          ...newPlan.attributes,
          monthly_total: planTotal({
            plan: newPlan,
            membersCovered: newPlan.attributes.employees_covered,
            billingType: newPlan.attributes.payment_mode,
          }),
        },
      });
    }
  };

  return (
    <>
      <section>
        <h1 className="mb-3">Additional Services</h1>

        <p>Please choose additional services that you’d like to add to your policy.</p>
      </section>

      <section>
        <Row>
          <Col md={7} style={{ maxHeight: '600px', overflowY: 'auto' }}>
            <h3>Services</h3>
            <p>Select any of the services below to add your policy.</p>

            {services === null && <LoadingPlaceholder text="Loading services..." className="pt-5" /> }

            {services && services.map((service) => (
              <BlockWithCheckbox
                key={service.id}
                checkboxValue={service.id}
                title={service.attributes.name}
                description={(
                  <>
                    <b>
                      {mark}
                      {formatCurrency(service.attributes.currency_prices
                        .find((item) => item.currency === abbr)?.price, abbr)}
                    </b>
                    {' '}
                    per month
                  </>
                )}
                checked={selectedTopics.includes(service.attributes.name)}
                onChange={onServiceClicked}
              />
            ))}
          </Col>

          <Col md={5}>
            <h3>Your plan summary</h3>
            <p>Here&apos;s a summary of your plan so far.</p>

            <ShortSummary plan={plan} />
          </Col>
        </Row>
      </section>

      <footer className="d-md-flex flex-row-reverse">
        <div className="mb-3 mb-md-0 ms-md-3">
          <Link
            to={routes.managers.plans.new.summary}
            className="btn btn-primary w-100"
            state={{ data: { ...data, plan } }}
          >
            Continue
          </Link>
        </div>

        <div className="flex-grow-1 d-flex justify-content-between">
          <Link
            to={routes.managers.plans.new.plan_details}
            className="btn btn-primary btn-reverse"
            state={{ data }}
          >
            Previous
          </Link>

          <Link
            to={routes.managers.policy.index}
            className="btn btn-outline-primary"
            state={{ data: { ...data, plan } }}
          >
            Cancel
          </Link>
        </div>
      </footer>
    </>
  );
}
